export default __webpack_public_path__ + "menu-configure-smop-icon.a6bb7730a128c54549b99e5aed9f5393.svg";